import { FILTER_RELATIVE_DATE_RANGE, FilterTypeEnum as FilterType } from '@creditsights/api-ui-web';

export { FilterTypeEnum as FilterType, FilterDto, FilterItemDto } from '@creditsights/api-ui-web';

export interface FilterItem {
  tagId: string;
  displayName: string;
  children?: FilterItem[];
}

export interface Filter {
  type: FilterType;
  options: FilterItem[];
}

export const CREDIT_GRADE_SPECIAL_SITUATIONS_TAG = 'tag/special_situations';
export const DateFilterOption = 'date';
export const KeywordFilterOption = 'keyword';
export type FilterOption = FilterType | typeof DateFilterOption | typeof KeywordFilterOption;
export const CONTENT_TYPE_FILTER_PARAMETER = 'type';

export const FILTER_TYPE_LABELS_SINGULAR: Record<FilterType, string> = {
  [FilterType.creditGrade]: 'Credit Grade',
  [FilterType.region]: 'Region',
  [FilterType.source]: 'Content Type',
  [FilterType.news_source]: 'Content Type',
  [FilterType.covenants_source]: 'Content Type',
  [FilterType.sector]: 'Sector/Subsector',
  [FilterType.topic]: 'Topic',
  [FilterType.report]: 'Report',
  [FilterType.assetClass]: 'Asset Class',
};

export const FILTER_TYPE_LABELS_PLURAL: Record<FilterType, string> = {
  [FilterType.creditGrade]: 'Credit Grades',
  [FilterType.region]: 'Regions',
  [FilterType.source]: 'Content Types',
  [FilterType.news_source]: 'Content Types',
  [FilterType.covenants_source]: 'Content Types',
  [FilterType.sector]: 'Sectors/Subsectors',
  [FilterType.topic]: 'Topics',
  [FilterType.report]: 'Reports',
  [FilterType.assetClass]: 'Asset Classes',
};

export interface TreeModelParameters {
  options: FilterItem[];
  filter?: (item: FilterItem) => boolean;
}

export interface TagOptionParameters {
  option: FilterItem;
  filter?: (item: FilterItem) => boolean;
  currentDepth?: number;
}

export interface Filters {
  tags?: Record<string, string[]>;
  startDate?: Date;
  endDate?: Date;
  relativeRange?: FILTER_RELATIVE_DATE_RANGE;
  titleContains?: string;
  keyword?: string;
}
